export class RaceCourseDisplayed {
    RaceCourse: number;
    Track: number; // Not available for barrier trial
    TrackEng: string; // For English only (redundant)
    RaceDistance: number;
    color: string;
    backgroundColor: string;
    raceCourseShortForm: string;
    raceDistanceDisplayed: string;
    raceDistanceDisplayedFull: string;
  }
  


// WEBPACK FOOTER //
// ./src/model/RaceCourseDisplayed.ts